import { useRef } from 'react';
import { motion, useInView, useScroll, useTransform } from 'framer-motion';

const CTA_IMAGE = "https://customer-assets.emergentagent.com/job_swiss-logistics/artifacts/6ybdvhfm_BUS.jpg";

export default function CTABanner() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-100px" });
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"]
  });
  const bgY = useTransform(scrollYProgress, [0, 1], [0, -80]);

  const scrollToDevis = (e) => {
    e.preventDefault();
    const el = document.querySelector('#devis');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section ref={ref} className="relative py-24 md:py-32 overflow-hidden" data-testid="cta-banner-section">
      {/* Parallax BG */}
      <motion.div
        style={{
          y: bgY,
          backgroundImage: `url(${CTA_IMAGE})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
        className="absolute inset-0 scale-110"
      />
      <div className="absolute inset-0 bg-[#0A0A0A]/85" />

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-12 text-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
        >
          <div className="w-16 h-1 bg-[#FF0000] mx-auto mb-8" />
          <h2
            className="font-['Oswald'] text-3xl sm:text-4xl lg:text-5xl font-bold uppercase tracking-tight text-white mb-6"
            data-testid="cta-title"
          >
            Prêt à planifier votre transport ?
          </h2>
          <p className="text-white/60 text-base md:text-lg mb-10 max-w-2xl mx-auto">
            Obtenez votre devis gratuit en quelques minutes. Notre équipe vous répondra sous 24 heures.
          </p>
          <a
            href="#devis"
            onClick={scrollToDevis}
            className="inline-block bg-[#FF0000] hover:bg-[#D90000] text-white px-10 py-5 text-sm font-bold uppercase tracking-widest transition-all hover:scale-105"
            data-testid="cta-btn-devis"
          >
            Obtenir un devis gratuit
          </a>
        </motion.div>
      </div>
    </section>
  );
}
